import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'
import cn from 'classnames'
import { scrollToFilters, URLDateParam } from '../../../utils'
import { FILTER_DATES } from '../../../constants'

import './button.scss'

class Button extends PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    unavailableLabel: PropTypes.string,
    isAvailable: PropTypes.bool,
    filterType: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    isApplied: PropTypes.bool.isRequired,
    className: PropTypes.string,
    dates: PropTypes.arrayOf(Array),
    placeholders: PropTypes.objectOf(Object),
    roomsTitles: PropTypes.objectOf(Object),
  }

  static defaultProps = {
    className: null,
    unavailableLabel: 'See available dates',
    isAvailable: false,
    dates: [],
    placeholders: null,
    roomsTitles: {},
  }

  constructor(props) {
    super(props)
    this.inputStart = React.createRef()
    this.inputEnd = React.createRef()
  }

  getLabel = () => {
    const {
      label,
      isAvailable,
      unavailableLabel,
      filterType,
    } = this.props

    if (filterType === 'availableDates') {
      if (isAvailable) {
        return parse(label)
      }
      return unavailableLabel
    }
    return parse(label)
  }

  handleClick = (event) => {
    event.stopPropagation()
    const { onClick, filterType } = this.props
    const isAvailableDates = filterType === 'availableDates'
    onClick(isAvailableDates ? 'dates' : filterType, event, isAvailableDates)
    scrollToFilters('.search-home', 0)
  }

  handleInputRange = () => {
    const startDateValue = this.inputStart.current.value
    const endDateValue = this.inputEnd.current.value
    let startDate = startDateValue ? new Date(startDateValue) : null
    let endDate = endDateValue ? new Date(endDateValue) : null

    if (startDate && startDate <= new Date()) {
      startDate = new Date()
    }

    if (endDate && endDate < startDate) {
      endDate = ''
    }

    this.changeStore([startDate, endDate], false)
  }

  changeStore = (datesRange, apply) => {
    const { filterChangeAction, filterApplyAction, searchFilters } = this.props
    filterChangeAction(FILTER_DATES, datesRange, searchFilters.additionalValues)
    filterApplyAction(FILTER_DATES, apply, datesRange)
  }

  render() {
    const {
      isActive,
      isApplied,
      className,
      isAvailable,
      filterType,
      placeholders,
      dates,
      roomsTitles,
    } = this.props

    return (
      <React.Fragment>
        { filterType === 'dates' ? (
          <div
            className={cn('dates-inputs-wrap', filterType, className, {
              active: isActive,
              'reserve-book-btn': isAvailable,
              applied: dates,
            })}
            role={'button'}
            aria-label={placeholders !== null && placeholders.dateInPlaceholder}
            onClick={this.handleClick}
          >

            <div className="dates-inputs-wrap__icon">
              <i className="icon-CALENDAR" />
            </div>

            <div className={cn('input-control', '_dateStart')}>
              <div
                className="input-control__field"
              >
                { placeholders !== null && placeholders.dateInPlaceholder && (
                  <span className="input-control__label">
                    {placeholders.dateInPlaceholder}
                  </span>
                )}
                <input
                  required
                  className={cn('input-control__input input-control__input_start')}
                  type="date"
                  value={dates && dates[0] ? URLDateParam(dates[0]) : ''}
                  min={URLDateParam(new Date())}
                  onClick={this.handleClickInput}
                  ref={this.inputStart}
                  onBlur={() => {
                    this.handleInputRange()
                  }}
                />

                {dates && (
                  <span className="input-control__pretty_value">
                    {this.getLabel()}
                  </span>
                )}
              </div>
            </div>
            <div
              className={cn('input-control', '_dateEnd')}
            >
              <div className="input-control__field">
                { placeholders !== null && placeholders.dateOutPlaceholder && (
                  <span className="input-control__label">
                    {placeholders.dateOutPlaceholder}
                  </span>
                )}
                <input
                  required
                  className={cn('input-control__input input-control__input_end')}
                  type="date"
                  onClick={this.handleClickInput}
                  value={dates && dates[1] ? URLDateParam(dates[1]) : ''}
                  ref={this.inputEnd}
                  onBlur={() => {
                    this.handleInputRange()
                  }}
                />
                {isApplied && (
                  <span className="input-control__pretty_value">
                    {this.getLabel()}
                  </span>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            className={cn(filterType === 'code' ? 'search-filter-codes' : 'search-filter-button', filterType, className, {
              active: isActive,
              'reserve-book-btn': isAvailable,
              applied: isApplied,
            })}
            onClick={this.handleClick}
            role="button"
            aria-label={filterType === 'rooms' ? roomsTitles.label : this.getLabel()}
          >

            {filterType === 'rooms' && (
              <React.Fragment>
                <div className="dates-inputs-wrap__icon">
                  <i className="icon-PARTICIPANT"/>
                </div>
                <div className={'input-control__label'}> {roomsTitles.label} </div>
              </React.Fragment>
            ) }

            {filterType === 'code' && (
              <React.Fragment>
                <div className="dates-inputs-wrap__icon">
                  <svg aria-labelledby="icon_percent">
                    <use xlinkHref="#icon_percent" />
                  </svg>
                </div>
              </React.Fragment>
            ) }

            <div className={cn(filterType === 'code' ? 'search-filter-codes__label' : 'search-filter-button__label', isActive && 'active', isApplied && 'applied')}>
              <div className="search-filter-codes__label-text">
                {this.getLabel()}
              </div>
            </div>
          </div>
        )
        }
      </React.Fragment>
    )
  }
}


export default Button
